function CohablistHome() {
  return (
    <div style={{ maxWidth: 720, margin: '60px auto', padding: '0 24px 80px', fontFamily: 'inherit', lineHeight: 1.7, color: '#222' }}>
      <h1 style={{ fontSize: '1.6rem', marginBottom: 4 }}>Cohablist</h1>
      <p style={{ color: '#666', marginTop: 0, marginBottom: 32 }}>Shared living, sorted.</p>

      <p>
        Cohablist is a shared household app for flatmates and couples. It brings the everyday
        logistics of living together — the grocery list, the chores, the upcoming plans — into
        one place that everyone in the home can see and update together.
      </p>

      <h2>What it does</h2>
      <ul>
        <li><strong>Shared grocery list</strong> — add items as you run out, check them off as they're bought.</li>
        <li><strong>Chores</strong> — track who's doing what and when it's due.</li>
        <li><strong>Upcoming events</strong> — keep the household in sync on what's coming up.</li>
      </ul>

      <p>
        You sign in with your Google account, join or create a household group with an invite
        code, and everything you and your housemates add stays in sync in real time.
      </p>

      <h2>Legal</h2>
      <ul>
        <li><a href="/cohablist/privacy">Privacy Policy</a></li>
        <li><a href="/cohablist/tos">Terms of Service</a></li>
      </ul>

      <h2>Contact</h2>
      <p>
        Questions about the app:&nbsp;
        <a href="mailto:dennis.hvel@gmail.com">dennis.hvel@gmail.com</a>
      </p>
    </div>
  );
}

export default CohablistHome;
